import base from './base'
import { styled } from '@egoist/vue-emotion'

export default styled(base)`
  width: ${props => props.theme.selected.button.height}px;
  height: ${props => props.theme.selected.button.height}px;
`
